class MainSearch extends SearchForm {
  constructor() {
    super();
    this.setUpTabs();
    this.allSearchInputs = this.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setUpTabs() {
    const pagesTab = document.querySelector('.result_type_navigation__tab--pages');
    if (!pagesTab) return;

    const isPageSearch = pagesTab.classList.contains('btn--active');
    const searchType = isPageSearch ? 'product' : 'page,article';

    const formData = new FormData();
    const searchQuery = this.input ? this.input.value : new URLSearchParams(window.location.search).get('q');
    formData.append('q', searchQuery);
    formData.append('type', searchType);

    fetch(`${routes.search_url}`, {
      method: 'POST',
      body: formData,
    }).then((response) => response.text())
    .then((text) => {
      const resultsCount = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('h1').dataset.resultCount;

      const totalResultsCount = Number.parseInt(resultsCount) + Number.parseInt(document.querySelector('h1').dataset.resultCount);

      const productsTab = document.querySelector('.result_type_navigation__tab--products');
      const pagesTabElement = document.querySelector('.result_type_navigation__tab--pages');

      if (isPageSearch) {
        if (productsTab.tagName === 'A') {
          productsTab.textContent = `${productsTab.dataset.tabLabel} (${resultsCount})`;
          if (resultsCount == 0) {
            productsTab.classList.add('disabled');
          }
        }
      } else if (pagesTabElement.tagName === 'A') {
        pagesTabElement.textContent = `${pagesTabElement.dataset.tabLabel} (${resultsCount})`;
        if (resultsCount == 0) {
          pagesTabElement.classList.add('disabled');
        }
      }

      if (totalResultsCount === 0) {
        const productsLabel = productsTab.textContent;
        productsTab.outerHTML = `<span class="btn btn--pill btn--sm btn--active result_type_navigation__tab result_type_navigation__tab--products" data-tab-label="${productsTab.dataset.tabLabel}">${productsLabel}</span>`;
        pagesTabElement.classList.remove('btn--active');
      }
    });
  }

  setupEventListeners() {
    if (!this.input) return;

    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
